import { useEffect, useState } from 'react'
import { firestore } from '../../utils/firebase/firebase'

const useStudio = (id) => {
  const [studio, setStudio] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()

  useEffect(() => {
    const unsubscribe = firestore
      .collection('studios')
      .doc(id)
      .onSnapshot(
        (doc) => {
          if (!doc.exists) {
            setError('Studio not found, please try again.')
            setLoading(false)
          } else {
            setStudio({ ...doc.data(), id: doc.id })
            setLoading(false)
          }
        },
        (error) => {
          setError('Error retrieving Studio: ', error.message)
          setLoading(false)
        }
      )

    return () => {
      unsubscribe()
    }
  }, [id])

  return { studio, loading, error }
}

export default useStudio
